import { render, staticRenderFns } from "./CreateSettingNotification.vue?vue&type=template&id=768e9c72"
import script from "./CreateSettingNotification.vue?vue&type=script&lang=js"
export * from "./CreateSettingNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports